import React from 'react';

import SuperSearchDropdown from 'NewComponents/FormComponents/SuperSearchDropdown/SuperSearchDropdown';
import TaskAssigneeSuperSearchInput from './TaskAssigneeSuperSearchInput';
import TaskAssigneeSuperSearchTemplate from './TaskAssigneeSuperSearchTemplate';

const TaskAssigneeSuperSearch = ({ searchValue, onChange, handleSelectedData, disabled, identifier = 'TaskAssigneeSuperSearch' }) => {
  return (
    <SuperSearchDropdown handleSelectedData={handleSelectedData}>
      <SuperSearchDropdown.Input>
        <TaskAssigneeSuperSearchInput
          disabled={disabled}
          searchValue={searchValue}
          onChange={onChange}
          handleSelectedData={handleSelectedData}
          identifier={identifier}
          placeholder='Search Assignee...'
        />
      </SuperSearchDropdown.Input>
      <SuperSearchDropdown.Container>
        <TaskAssigneeSuperSearchTemplate width='100%' handleSelectedData={handleSelectedData} identifier={identifier} />
      </SuperSearchDropdown.Container>
    </SuperSearchDropdown>
  );
};

export default TaskAssigneeSuperSearch;
